module.exports = __webpack_public_path__ + "img/logo.7ea4d3d1.svg";